/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum CcbSwitchVersion {
    CCBAPPROVED,
    DEVELOPER,
    NOTIMPLEMENTED,
    QEREADY,
    TAKEHOME,
    TEST,
}
